import { BLACK, DISCONTINUED } from '~/core/constants';
import { ProductType } from '~/core/enums';
import { ColorModel } from '~/core/models';
import { convertProductsToProductDetailsList } from '~/core/utils';

export const setDefaultUrlToColors = (
  colors: ColorModel[],
  defaultUrl: string
): ColorModel[] =>
  colors.map((color) => ({
    ...color,
    swatchImageUrl: color.swatchImageUrl || defaultUrl,
  }));

export const getColorsWithPrice = (colors: ColorModel[]): ColorModel[] =>
  colors.filter((color) => color.price > 0);

export const getAvailableColors = (colors: ColorModel[]): ColorModel[] =>
  colors.filter((color) => !color.name.toLowerCase().includes(DISCONTINUED));

export const convertColorsToProductDetails =
  convertProductsToProductDetailsList(ProductType.COUNTERTOP);

// Utility function to parse hex color strings
// Accepts 6-digit hex (#RRGGBB) and 8-digit hex (#AARRGGBB), returns 6-digit hex
// If input is invalid, returns defaultColor (black by default)
export const parseHexColor = (
  hex: string | undefined,
  defaultColor = BLACK
): string => {
  const hexMatch = hex?.match(/^#?([0-9a-f]{6}|[0-9a-z]{8})$/i);

  return hexMatch ? `#${hexMatch[1].slice(-6)}` : defaultColor;
};

export const invertColor = (hex: string, bw: boolean): string => {
  const padZero = (str: string, len = 2) => {
    const zeros = new Array(len).join('0');

    return (zeros + str).slice(-len);
  };

  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }

  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  if (bw) {
    // https://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
  }

  // invert color components
  const rs = (255 - r).toString(16).toUpperCase();
  const gs = (255 - g).toString(16).toUpperCase();
  const bs = (255 - b).toString(16).toUpperCase();

  // pad each with zeros and return
  return '#' + padZero(rs) + padZero(gs) + padZero(bs);
};
